import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup, Input, Label, InputGroup, Alert } from 'reactstrap'
import { processYield } from '../../../formulas/processYield'

export default class ProcessYieldForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasResult: false,
            hasError: false,
            error: ''
        }
    }

    handleChange = (e) => {
        const target = e.target
        if (!target.value) {
            target.value = 0 // Si on enlève la valeur, on la passe à 0
        }
        this.props.formToState({ [target.name]: parseFloat(target.value) }) // Redux
    }

    calculateProcessYield = (e) => {
        e.preventDefault()
        e.stopPropagation()
        try {
            const formValues = this.props.processYieldValues
            delete formValues.result
            const result = processYield(formValues)
            this.props.formToState({ result }) // Redux
            this.setState({ hasResult: true, hasError: false })
        } catch (e) {
            console.log(e)
            this.setState({ hasError: true, hasResult: false, error: "Calculation impossible" })
        }
    }

    render() {
        return (
            <Form onSubmit={this.calculateProcessYield}>
                <FormGroup>
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="phosphorusPentoxideG"><b>%</b> P2O5 gypsum (dry, 50 or 250°C)</Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="phosphorusPentoxideG" id="phosphorusPentoxideG" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="phosphorusPentoxideQQ"><b>%</b> P2O5 rock (dry rock)</Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="phosphorusPentoxideQQ" id="phosphorusPentoxideQQ" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="phosphorusPentoxideAcid"><b>%</b> P2O5 acid (product acid)</Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="phosphorusPentoxideAcid" id="phosphorusPentoxideAcid" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="calciumOxideG"><b>%</b> CaO gypsum (dry, 50 or 250°C)</Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="calciumOxideG" id="calciumOxideG" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="calciumOxideQQ"><b>%</b> CaO rock (dry rock)</Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="calciumOxideQQ" id="calciumOxideQQ" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="calciumOxideAcid"><b>%</b> CaO acid (product acid)</Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="calciumOxideAcid" id="calciumOxideAcid" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                </FormGroup>
                {/** Submit */}
                <Input type="submit" value="Calculate process yield" className="custom-button" onClick={this.calculateProcessYield} />
                <br />
                {/** Résultat */}
                {this.state.hasResult ?
                    <div className="formula-result text-center">
                        The process yield is {this.props.processYieldValues.result} %
                    </div>
                    : null}
                {this.state.hasError ?
                    <div className="text-center">
                        <Alert color="danger">
                            {this.state.error}
                        </Alert>
                    </div>
                    : null}
            </Form>
        )
    }
}

ProcessYieldForm.propTypes = {
    processYieldValues: PropTypes.shape({
        phosphorusPentoxideG: PropTypes.number,
        phosphorusPentoxideQQ: PropTypes.number,
        phosphorusPentoxideAcid: PropTypes.number,
        calciumOxideG: PropTypes.number,
        calciumOxideQQ: PropTypes.number,
        calciumOxideAcid: PropTypes.number,
        result: PropTypes.number
    }),
    formToState: PropTypes.func
}